export const headCopy = {
	head_playground_title:
		"Area Bermain - Sebuah editor daring untuk menjelajahi TypeScript dan JavaScript",
	head_playground_description:
		"Area Bermain membuat Anda bisa menulis TypeScript atau JavaScript secara daring dengan aman dan bisa dibagikan.",
	tsconfig_title: "Referensi TSConfig - Dokumentasi bagi setiap opsi TSConfig",
	tsconfig_description:
		"Dari allowJs hingga useDefineForClassFields referensi TSConfig meliputi informasi tentang semua tanda kompiler yang aktif untuk mengatur projek TypeScript.",
	playground_example_prefix: "Contoh Area Bermain - ",
	head_index_title: "JavaScript dengan Tipe dalam skala apapun",
	head_index_description: "JavaScript dengan Tipe dalam skala apapun",
}
